module.exports = __webpack_public_path__ + "img/2336354f44cf8e07d2c230418d63d954.2336354f.png";